  import React, { useState } from "react";
  import { PropTypes } from "prop-types";
  import { connect } from "react-redux";
  import { withRouter } from "react-router-dom";
  import { Link } from "react-router-dom";
  import * as Icons from "../../assets/Icons";
  import logonew from "../../images/logosm-new.svg";
  import { getProviderLabel } from "../../utils/providerApi";
  const getWebUrlpermission = (props, currentTab) => {
    let found = 0;
    let webpermissionArr =
      props && props.user && props.user.details.permissions
        ? props.user.details.permissions.web_url_permission
        : [];
    for (var i = 0; i < webpermissionArr.length; i++) {
      if (webpermissionArr[i].url === currentTab) {
        found = 1;
        break;
      }
    }
    return found;
  };

  const getDevopsRole = (props) => {
    let Devopsfound = 0;
    if (
      props &&
      props.user &&
      props.user.details.permissions &&
      props.user.details.permissions.full_permission === true
    ) {
      Devopsfound = 1;
    }
    return Devopsfound;
  };

  const getRoles = (props) => {
    let UserAccess = 0;
    for (var i = 0; i < props.user.details.role.length; i++) {
      if (props.user.details.role[i]["id"] === 1) {
        UserAccess = 1;
        break;
      }
      if (props.user.details.role[i]["id"] === 2) {
        UserAccess = 1;
        break;
      }
      if (props.user.details.role[i]["id"] === 3) {
        UserAccess = 1;
        break;
      }
      if (props.user.details.role[i]["id"] === 5) {
        UserAccess = 1;
        break;
      }
      if (props.user.details.role[i]["id"] === 10) {
        UserAccess = 10;
        break;
      }
    }
    return UserAccess;
  };

  const Sidebar = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const provider = props.selectedProvider || "azure";
    const label = (key) => getProviderLabel(provider, key);

    const toggleSidebar = () => {
      setIsOpen(!isOpen);
    };
    const closeSidebar = () => {
      setIsOpen(!isOpen);
    };
    return (
      <div className={`sidebar-wrapper ${isOpen ? "open" : ""}`}>
        <button
          className={`menu-btn ${isOpen ? "open" : ""}`}
          onClick={toggleSidebar}
        ></button>
        <div className="nav flex-column  nav-tabs" id="nav-tab" role="tablist">
          <div className="logo-section">
            <Link
              className="navbar-brand navbar-brand-logo"
              to="/azure-dashboard"
            >
              <img src={logonew} alt="Logo" style={{ width: 204, height: 50 }} />
            </Link>
          </div>

          {/* <Link
            className={
              props.location.pathname === "/azure-accounts" ||
              props.location.pathname.indexOf("azure-accounts") !== -1
                ? "nav-item nav-link active"
                : "nav-item nav-link"
            }
            to="/azure-accounts"
            onClick={closeSidebar}
          >
            <span className="icon">
              {" "}
              <Icons.Accounts />
            </span>{" "}
            Accounts
          </Link> */}

          <Link
            className={
              props.location.pathname === "/azure-dashboard" ||
              props.location.pathname.indexOf("azure-dashboard") !== -1
                ? "nav-item nav-link active"
                : "nav-item nav-link"
            }
            to="/azure-dashboard"
            onClick={closeSidebar}
          >
            <span className="icon">
              {" "}
              <Icons.Accounts />
            </span>{" "}
            Dashboard
          </Link>

          <div className="m-0 drop-menu">
            <button
              className="accordion-button nav-item nav-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#servicesmanagement"
              aria-expanded="false"
              aria-controls="servicesmanagement"
            >
              <span className="icon">
                {" "}
                <Icons.Container />
              </span>{" "}
              Services
            </button>

            <div className="collapse item-acc" id="servicesmanagement">
              <div className=" ">
                <Link
                  className={
                    props.location.pathname === "/azure-subcription" ||
                    props.location.pathname.indexOf("azure-subcription") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-subcription"
                  onClick={closeSidebar}
                >
                  {/* <span className="icon">
                    {" "}
                    <Icons.Subscriptions />{" "}
                  </span>{" "} */}
                  {label("subscriptions")}
                </Link>
                {/* <Link
                  className={
                    props.location.pathname === "/azure-activity-logs" ||
                    props.location.pathname.indexOf("azure-activity-logs") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-activity-logs"
                  onClick={closeSidebar}
                >

                  Activity Logs
                </Link> */}
                {/* <Link
                  className={
                    props.location.pathname === "/azure-vms" ||
                      props.location.pathname.indexOf("azure-vms") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-vms"
                  onClick={closeSidebar}
                >
                  Vms
                </Link> */}
                {/* <Link
                  className={
                    props.location.pathname === "/vms-images" ||
                      props.location.pathname.indexOf("vms-images") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/vms-images"
                  onClick={closeSidebar}
                >

                  Vms Images
                </Link> */}
                <Link
                  className={
                    props.location.pathname === "/azure-storage-accounts" ||
                    props.location.pathname.indexOf("azure-storage-accounts") !==
                      -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-storage-accounts"
                  onClick={closeSidebar}
                >
                  {/* <span className="icon">
                    {" "}
                    <Icons.Storage />{" "}
                  </span> */}
                  {label("storageAccounts")}
                </Link>
                {provider !== "gcp" && (
                <Link
                  className={
                    props.location.pathname === "/az-str-container" ||
                    props.location.pathname.indexOf("az-str-container") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-str-container"
                  onClick={closeSidebar}
                >
                  {label("storageContainer")}
                </Link>
                )}
                <Link
                  className={
                    props.location.pathname === "/azure-databases" ||
                    props.location.pathname.indexOf("azure-databases") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-databases"
                  onClick={closeSidebar}
                >
                  {/* <span className="icon">
                    {" "}
                    <Icons.Database />
                  </span>{" "} */}
                  {label("databases")}
                </Link>
                {provider !== "gcp" && (
                <Link
                  className={
                    props.location.pathname === "/az-sites" ||
                    props.location.pathname.indexOf("az-sites") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-sites"
                  onClick={closeSidebar}
                >
                  Sites
                </Link>
                )}
                {/* <Link
                  className={
                    props.location.pathname === "/users" ||
                    props.location.pathname.indexOf("users") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/users"
                  onClick={closeSidebar}
                >
                  <span className="icon">
                    {" "}
                    <Icons.Users />{" "}
                  </span>{" "}
                  Users
                </Link> */}
                <Link
                  className={
                    props.location.pathname === "/az-function-app" ||
                    props.location.pathname.indexOf("az-function-app") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-function-app"
                  onClick={closeSidebar}
                >
                  {label("functionApp")}
                </Link>
                {/* <Link
                  className={
                    props.location.pathname === "/az-load-balancer" ||
                    props.location.pathname.indexOf("az-load-balancer") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-load-balancer"
                  onClick={closeSidebar}
                >
                  Load Balancer
                </Link> */}

                <Link
                  className={
                    props.location.pathname === "/az-cdn" ||
                    props.location.pathname.indexOf("az-cdn") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-cdn"
                  onClick={closeSidebar}
                >
                  {/* <span className="icon">
                    {" "}
                    <Icons.Cdn />{" "}
                  </span>{" "} */}
                  {label("cdn")}
                </Link>
                {provider === "gcp" && (
                <Link
                  className={
                    props.location.pathname === "/compute-instances"
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/compute-instances"
                  onClick={closeSidebar}
                >
                  {label("computeEngine")}
                </Link>
                )}
                {provider === "gcp" && (
                <Link
                  className={
                    props.location.pathname === "/cloud-run"
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/cloud-run"
                  onClick={closeSidebar}
                >
                  {label("cloudRun")}
                </Link>
                )}
                {provider === "gcp" && (
                <Link
                  className={
                    props.location.pathname === "/secret-manager"
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/secret-manager"
                  onClick={closeSidebar}
                >
                  {label("secretManager")}
                </Link>
                )}
              </div>
            </div>
          </div>

          <div className="m-0 drop-menu">
            <button
              className="accordion-button nav-item nav-link collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#costmanagement"
              aria-expanded="false"
              aria-controls="costmanagement"
            >
              <span className="icon">
                {" "}
                <Icons.Billings />
              </span>{" "}
              Financial
            </button>

            <div className="collapse item-acc" id="costmanagement">
              <div className=" ">
                <Link
                  className={
                    props.location.pathname === "/azure-billing" ||
                    props.location.pathname.indexOf("azure-billing") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-billing"
                  onClick={closeSidebar}
                >
                  {label("billings")}
                </Link>
                <Link
                  className={
                    props.location.pathname === "/azure-forecast-billing" ||
                    props.location.pathname.indexOf("azure-forecast-billing") !==
                      -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-forecast-billing"
                  onClick={closeSidebar}
                >
                  {label("billingForecast")}
                </Link>
              </div>
            </div>
          </div>

          <div className="m-0 drop-menu">
            <button
              className="accordion-button  collapsed nav-item nav-link"
              type="button"
              data-toggle="collapse"
              data-target="#monitor"
              aria-expanded="false"
              aria-controls="monitor"
            >
              <span className="icon">
                {" "}
                <Icons.Monitor />{" "}
              </span>{" "}
              Monitor
            </button>

            <div className="collapse item-acc" id="monitor">
              <div className=" ">
                {/* <Link
                  className={
                    props.location.pathname === "/az-monitor-storage-account" ||
                    props.location.pathname.indexOf(
                      "az-monitor-storage-account"
                    ) !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-monitor-storage-account"
                  onClick={closeSidebar}
                >
                  Storage Account
                </Link> */}
                {/* <Link
                  className={
                    props.location.pathname === "/az-monitor-applications" ||
                    props.location.pathname.indexOf("az-monitor-applications") !==
                      -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-monitor-applications"
                  onClick={closeSidebar}
                >
                  Applications
                </Link> */}

                <Link
                  className={
                    props.location.pathname === "/az-alert-rules" ||
                    props.location.pathname.indexOf("az-alert-rules") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-alert-rules"
                  onClick={closeSidebar}
                >
                  {label("alertRules")}
                </Link>
                <Link
                  className={
                    props.location.pathname === "/az-active-alert" ||
                    props.location.pathname.indexOf("az-active-alert") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-active-alert"
                  onClick={closeSidebar}
                >
                  {label("activeAlert")}
                </Link>
                <Link
                  className={
                    props.location.pathname === "/az-previous-alert-rules" ||
                    props.location.pathname.indexOf("az-previous-alert-rules") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/az-previous-alert-rules"
                  onClick={closeSidebar}
                >
                  {label("previousAlerts")}
                </Link>
              </div>
            </div>
          </div>

          <div className="m-0 drop-menu">
            <button
              className="accordion-button  collapsed nav-item nav-link"
              type="button"
              data-toggle="collapse"
              data-target="#metrics"
              aria-expanded="false"
              aria-controls="metrics"
            >
              <span className="icon">
                {" "}
                <Icons.Metrics />{" "}
              </span>{" "}
              Metrics
            </button>

            <div className="collapse item-acc" id="metrics">
              <div className=" ">
                <Link
                  className={
                    props.location.pathname === "/azure-console-logs" ||
                    props.location.pathname.indexOf("azure-console-logs") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-console-logs"
                  onClick={closeSidebar}
                >
                  {label("consoleLogs")}
                </Link>
                <Link
                  className={
                    props.location.pathname === "/azure-metrics-logs" ||
                    props.location.pathname.indexOf("azure-metrics-logs") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-metrics-logs"
                  onClick={closeSidebar}
                >
                  {label("metricsLogs")}
                </Link>

                {/* Metrics Dashboard - Commented Out */}
                {/* <Link
                  className={
                    props.location.pathname === "/azure-live-metrics" ||
                    props.location.pathname.indexOf("azure-live-metrics") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-live-metrics"
                  onClick={closeSidebar}
                >
                  Metrics Dashboard
                </Link> */}

                {/* <Link
                  className={
                    props.location.pathname === "/azure-performance-insight" ||
                      props.location.pathname.indexOf(
                        "azure-performance-insight"
                      ) !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-performance-insight"
                  onClick={closeSidebar}
                >
                  Performance Insight
                </Link> */}

                {/* <Link
                  className={
                    props.location.pathname === "/azure-metrics-availability" ||
                      props.location.pathname.indexOf(
                        "azure-metrics-availability"
                      ) !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-metrics-availability"
                  onClick={closeSidebar}
                >
                  Availability
                </Link>
                <Link
                  className={
                    props.location.pathname === "/azure-metrics-request" ||
                      props.location.pathname.indexOf("azure-metrics-request") !==
                      -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-metrics-request"
                  onClick={closeSidebar}
                >
                  Request
                </Link>
                <Link
                  className={
                    props.location.pathname === "/azure-metrics-response" ||
                      props.location.pathname.indexOf("azure-metrics-response") !==
                      -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-metrics-response"
                  onClick={closeSidebar}
                >
                  Response
                </Link> */}

                {/* <Link
                  className={
                    props.location.pathname === "/azure-metrics-failed" ||
                      props.location.pathname.indexOf("azure-metrics-failed") !== -1
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  to="/azure-metrics-failed"
                  onClick={closeSidebar}
                >
                  Failed
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  Sidebar.propTypes = {
    headingName: PropTypes.string,
  };

  const mapStateToProps = (state) => ({
    selectedProvider: state.CloudProviderStore
      ? state.CloudProviderStore.selectedProvider
      : "azure",
  });

  export default connect(mapStateToProps)(withRouter(Sidebar));
